import React from 'react'
import { StyleSheet } from 'react-native'
import { Spacing, Text, TextProps } from 'zens-storybook'
import { useBuilding, useLocation, useZone } from 'zens-store'

const styles = StyleSheet.create({
  container: {
    marginTop: Spacing.XS,
  },
})

interface Props extends TextProps {
  value: number
  companyId: number
}
const ZoneField = (props: Props) => {
  const { value: zoneId, companyId, style, ...otherProps } = props
  const zone = useZone({ companyId, zoneId })
  const building = useBuilding({
    companyId,
    buildingId: zone.data?.buildingId || NaN,
  })
  const location = useLocation({
    companyId,
    locationId: building?.data?.locationId || NaN,
  })
  return (
    <Text style={[styles.container, style]} {...otherProps}>
      {zone.data?.name} ({building.data?.name}, {location.data?.name})
    </Text>
  )
}

export default ZoneField
